import * as React from 'react';
import { useContext, useState } from "react";
import {
  Box,
  HStack,
  Heading,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Spacer,
  TabList,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  CopyIcon,
} from "@chakra-ui/icons";
// React Icons https://react-icons.github.io/react-icons/icons?name=md
import {
  MdEditSquare,
  MdHome,
  MdLogin,
  MdLogout,
  MdPublicOff,
  MdExpandLess,
} from "react-icons/md";

// Divider - Chakra UI https://chakra-ui.com/docs/components/divider
import { Divider } from '@chakra-ui/react'
import { useNavigate } from "react-router-dom";

import { GlobalContext } from "@/auth"

export const PageHeader: React.FunctionComponent<{
  title: string;
  children?: React.ReactNode;
}> = ({title, children}) => {
  const {globalState} = useContext(GlobalContext);
  return <HStack padding="2px" border="2px solid" margin={2} borderColor="#df6694" borderRadius="8px">
{ //hayashida
  //<MyMenu></MyMenu>
}
    <Heading size={"md"} m={4}>{title}</Heading>{children && <><Divider orientation={"vertical"}/><Box w="fit-content">{children}</Box></>}
    <Spacer/>
    <Text marginRight={4}>{globalState.currentUser.optFamilyName ?? ""} {globalState.currentUser.optName ?? ""}</Text>
  </HStack>
};

export const PageBody: React.FunctionComponent<{
  children: React.ReactNode,
}> = ({children}) => {
  return <Box padding={8}><VStack align='stretch' spacing={6}>
    {children}
  </VStack></Box>
}

export const Page: React.FunctionComponent<{
  children: React.ReactNode,
}> = ({children}) => {
  return <VStack align={"stretch"} spacing={0}>
    {children}
  </VStack>
};

type ParentProps = {
  readonly title: string;
  readonly children: React.ReactNode;
}

type ChildrenProps = {
  readonly title?: string;
  readonly children: React.ReactNode;
  onClick?: () => void;
}
const MyMenu: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { globalState } = useContext(GlobalContext);
  return <Menu>
    <MenuButton
      as={IconButton}
      aria-label='Options'
      icon={<HamburgerIcon />}
      variant='outline'
    />
    <MenuList>
      { globalState.currentUser.optRole && ["admin", "vendor", "teacher"].includes(globalState.currentUser.optRole) &&
        <MenuItem onClick={() => navigate("/manage")} icon={<MdHome />}>メニュー</MenuItem>
      }
      <MenuItem onClick={() => navigate("/login")} icon={<MdLogin />}>Login</MenuItem>
      <MenuItem onClick={() => navigate("/logout")} icon={<MdLogout />}>Logout</MenuItem>
      <MenuDivider />
      <MenuItem>Version: {process.env.VERSION}</MenuItem>
      {/* <MenuItem>Thumb: {process.env.HASH}</MenuItem> */}
      <MenuItem onClick={() => navigator.clipboard.writeText(`Version: ${process.env.VERSION} | Hash: ${process.env.HASH} | Build Time: ${process.env.BUILD_TIME}`)} icon={<CopyIcon />}>Copy Version Info</MenuItem>
      {/* <MenuItem>Build: {process.env.BUILD_TIME}</MenuItem> */}
    </MenuList>
  </Menu>
}

export const ExTabList = (props: ChildrenProps) => {
  const {globalState} = useContext(GlobalContext);

  return <TabList>
    <HStack padding="2">
      {/* <MyMenu></MyMenu> */}
      <Heading size={"md"}>{props.title}</Heading>
      <Divider orientation={"vertical"}/>
    </HStack>
    {props.children}
    <Spacer/>
    <HStack padding={2}>
      <Text marginRight={2}>{globalState.currentUser.optFamilyName ?? "Guest"}　{globalState.currentUser.optName ?? ""}</Text>
      <IconButton
        onClick={props.onClick}
        icon={<MdExpandLess />}
        aria-label="ヘッダーをかくす"
        zIndex={1000}
        isRound
        size="sm"
      />
    </HStack>
  </TabList>
}

export const ExPage = (props: ParentProps) => {
  // const newChildren = React.cloneElement(props.children as React.ReactElement<ChildrenProps>, {
  //   title: props.title,
  // })
  const newChildren = React.Children.map(props.children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }
    return React.cloneElement(child as React.ReactElement<ChildrenProps>, { title: props.title });
  });
  // const newChildren = props.children
  return <Box height={"100%"}>
    <Tabs variant='enclosed' display="flex" flexDirection="column" height="100%">
      {newChildren}
    </Tabs>
  </Box>
};
